import React, { Component } from "react";
import {  Icon, Message, Tab, Segment, Form, Table, Select, Input,Dropdown, List, Header } from 'semantic-ui-react'
import config from "../config";


// Register the plugins

export default class DecisionRules extends Component {
  constructor(props) {
    super(props);

    this.state={decisionRules: [], tabIndex: 0, uploadSuccess: false, uploadFailed: false};


  }

  
  componentDidMount ()
  {
      this.setState({decisionRules: this.props.data})
  }

  componentWillReceiveProps(newProps)
  {
    this.setState({decisionRules: newProps.data})
  }

  updateFieldValue(ruleid, fieldname, operator, value)
  {
    var copyData=this.state.decisionRules.slice();
    const currValue=copyData[ruleid][fieldname]

    // console.log(copyData[ruleid].criteria[fieldname])
    if (operator==="=")
      copyData[ruleid].criteria[fieldname]=value
    else
      copyData[ruleid].criteria[fieldname]={operator: operator, value: value}

      this.setState({decisionRules: copyData});
      this.props.onDataChange(copyData);
  }
  addField(ruleid, fieldname)
  {
    var copyData=this.state.decisionRules.slice();
    var value;
    const field=this.props.rulefields[fieldname];
    if ('values' in field)
    value=field.values[0].value;
    else if (field.type==='text')
    value='';
    else if (field.type==='boolean')
    value=false;
    else if (field.type==='numeric')
    value=0;
    copyData[ruleid].criteria[fieldname]=value;
    this.setState({decisionRules: copyData});
    this.props.onDataChange(copyData);
  }
  removeField(ruleid, fieldname)
  {
    var copyData=this.state.decisionRules.slice();
    delete copyData[ruleid].criteria[fieldname];
    this.setState({decisionRules: copyData});
    this.props.onDataChange(copyData);
  }  
  updateRuleValue(ruleid, fieldname,value)
  {
    console.log(fieldname, value)
    var copyData=this.state.decisionRules.slice();
    copyData[ruleid].value[fieldname]=value
    this.setState({decisionRules: copyData});
    this.props.onDataChange(copyData);
  }
  
  updateFieldOperator(ruleid, fieldname,operator)
  {
    var copyData=this.state.decisionRules.slice();
    var value=copyData[ruleid].criteria[fieldname];
    if (typeof value==='object')
      value=value.value;
    if (operator==='=')
      copyData[ruleid].criteria[fieldname]=value
    else
      copyData[ruleid].criteria[fieldname]={operator: operator, value: value}
    this.setState({decisionRules: copyData});
    this.props.onDataChange(copyData);
  }

  addRule(index)
  {
    var copyData=this.state.decisionRules.slice();
    copyData.splice(index, 0, {criteria: {}, value: {creditcheckstatus: 1, creditrating: 1}})
    this.setState({decisionRules: copyData});
    this.props.onDataChange(copyData);
  }

  deleteRule(index)
  {
    var copyData=this.state.decisionRules.slice();
    copyData.splice(index, 1)
    this.setState({decisionRules: copyData});
    this.props.onDataChange(copyData);
  }


  moveRuleUp(index)
  {
    var copyData=this.state.decisionRules.slice();
    const oldRule=Object.assign({}, copyData[index-1])
    copyData[index-1]=Object.assign({}, copyData[index])
    copyData[index]=oldRule;
    
    this.setState({decisionRules: copyData});
    this.props.onDataChange(copyData);
  }
  moveRuleDown(index)
  {
    var copyData=this.state.decisionRules.slice();
    const oldRule=Object.assign({}, copyData[index+1])
    copyData[index+1]=Object.assign({}, copyData[index])
    copyData[index]=oldRule;
    
    this.setState({decisionRules: copyData});
    this.props.onDataChange(copyData);
  }

  renderfield(ruleid, fieldname, value, fieldpos)
  {
    //console.log(ruleid, fieldname, value, fieldpos)
    const field=this.props.rulefields[fieldname]
    var operatoroptions;
    var fieldvalue;
    var operator;
    
    if (field.type==="numeric")
    operatoroptions=[{key: "=", value: "=", text: "="}, {key: "<", value: "<", text: "<"}, {key: "<=", value: "<=", text: "<="}, {key: ">", value: ">", text: ">"}, {key: ">=", value: ">=", text: ">="}, {key: "<>", value: "<>", text: "<>"}]
    else
    operatoroptions=[{key: "=", value: "=", text: "="}, {key: "<>", value: "<>", text: "<>"}]
    
    if (typeof value==='object' && value!==null)
    {
      fieldvalue=value.value;
      operator=value.operator;
    }
    else
    {
      fieldvalue=value;
      operator="=";
    }
    var prefix;
    if (fieldpos===0)
    prefix='If '
    else
    prefix='and '

    return <Table.Row>
      <Table.Cell>{prefix+field.description}</Table.Cell>
      <Table.Cell><Select compact disabled={!this.props.editmode} options={operatoroptions} value={operator} onChange={(event, data)=>{this.updateFieldOperator(ruleid, fieldname, data.value)}}/></Table.Cell>
      <Table.Cell>{this.renderfieldvalue(ruleid, fieldname, operator, field, fieldvalue)}</Table.Cell>
  <Table.Cell>{this.props.editmode && <a onClick={()=>{this.removeField(ruleid, fieldname)}}>delete</a>}</Table.Cell>
    </Table.Row>


  }

  renderfieldvalue(ruleid, fieldname, operator, field, fieldvalue)
  {
    if ('values' in field)
    return <Select options={field.values} disabled={!this.props.editmode} value={fieldvalue} onChange={(event, data)=>{this.updateFieldValue(ruleid, fieldname, operator, data.value)}} />
    else if (field.type==='boolean')
    return <Select disabled={!this.props.editmode} options={[{key: "True", value: true, text: "True"}, {key: "False", value: false, text: "False"}]} value={fieldvalue} onChange={(event, data)=>{this.updateFieldValue(ruleid, fieldname, operator, data.value)}} />
    else if (field.type==='text')
    return <Input type='text' disabled={!this.props.editmode} value={fieldvalue} onChange={(event, data)=>{this.updateFieldValue(ruleid, fieldname, operator, data.value)}}/>
    else if (field.type==='numeric')
    return <Input type='number' disabled={!this.props.editmode} value={fieldvalue} onChange={(event, data)=>{this.updateFieldValue(ruleid, fieldname, operator, Number(data.value))}}/>
          
  }


  renderrulevalue(ruleid, fieldname, field, fieldvalue)
  {
    if ('values' in field)
    return <Form.Select label={field.description} disabled={!this.props.editmode} options={field.values} value={fieldvalue} onChange={(event, data)=>{this.updateRuleValue(ruleid, fieldname, data.value)}} />
    else if (field.type==='boolean')
    return <Form.Select label={field.description} disabled={!this.props.editmode} options={[{key: "True", value: true, text: "True"}, {key: "False", value: false, text: "False"}]} value={fieldvalue} onChange={(event, data)=>{this.updateRuleValue(ruleid, fieldname, data.value)}} />
    else if (field.type==='text')
    return <Form.Input label={field.description} disabled={!this.props.editmode} type='text' value={fieldvalue} onChange={(event, data)=>{this.updateRuleValue(ruleid, fieldname, data.value)}}/>
    else if (field.type==='numeric')
    return <Form.Input type='number' label={field.description} disabled={!this.props.editmode} value={fieldvalue} onChange={(event, data)=>{this.updateRuleValue(ruleid, fieldname, data.value ? Number(data.value) : null)}}/>
          
  }


 render() {


        return (<div>
          {this.props.label && <Header as='h4' style={{color: this.props.darkmode ? "white": "black"}}>{this.props.label} {this.props.editmode && this.state.decisionRules.length===0 && <a onClick={()=>{this.addRule(0)}}>add</a>}</Header>}
          
          <Table collapsing striped>
              <Table.Header>
                <Table.HeaderCell>Criteria</Table.HeaderCell>
                <Table.HeaderCell/>
                <Table.HeaderCell>Value</Table.HeaderCell>

              </Table.Header>
              
              {this.state.decisionRules.map((rule,ruleid)=>
                {
                    return <Table.Body><Table.Row>
                      <Table.Cell>

                      <Table collapsing basic> 
                      <Table.Body>

                      <Table.Row>
                      <Table.Cell style={{"border-top-color": this.props.darkmode ? "white" : "black" }} colSpan='3'>
                      {Object.keys(rule.criteria).map((rulefield, fieldpos)=>{
                        return this.renderfield(ruleid, rulefield, rule.criteria[rulefield],fieldpos)
                      })}
                      {this.props.editmode && <Dropdown text='Add field'>
                        <Dropdown.Menu>
                          {Object.keys(this.props.rulefields).filter(fieldname=>{return !(fieldname in rule.criteria)}).map(fieldname=>
                            {
                              const field=this.props.rulefields[fieldname]
                              return <Dropdown.Item text={field.description} onClick={()=>{this.addField(ruleid, fieldname)}}/>
                            })}
                        </Dropdown.Menu>
                        </Dropdown>}
                      </Table.Cell>
                      </Table.Row>
                      </Table.Body>
                        </Table>
                      </Table.Cell>
                      <Table.Cell>
                        <Icon name='arrow right' size='huge'/>
                      </Table.Cell>
                      <Table.Cell>
                        <Form>
                        {Object.keys(this.props.valuefields).map(fieldName=>{
                            return this.renderrulevalue(ruleid, fieldName, this.props.valuefields[fieldName], rule.value[fieldName]);
                        })}
                          {/* <Form.Select label='Credit Check Result' value={rule.value.creditcheckstatus} options={[{key: 1, value: 1, text: "Passed"}, {key: 2, value: 2, text: "Failed"}]} onChange={(event, data)=>{this.updateRuleValue(ruleid, 'creditcheckstatus', data.value)}}/>
                          <Form.Select label='Credit Rating' value={rule.value.creditrating} options={[{key: 1, value: 1, text: "Minimum Risk"}, {key: 2, value: 2, text: "Lower Than Average Risk"}, {key: 3, value: 3, text: "Average Risk"}, {key: 4, value: 4, text: "Above Average Risk"}, {key: 5, value: 5, text: "High Risk"}]}  onChange={(event, data)=>{this.updateRuleValue(ruleid, 'creditrating', data.value)}}/> */}
                        </Form>
                      </Table.Cell>
                      <Table.Cell>
                      <List>
                        <List.Item>{this.props.editmode && <a onClick={()=>{this.deleteRule(ruleid)}}>delete</a>}</List.Item>
                        <List.Item>{this.props.editmode && <a onClick={()=>{this.addRule(ruleid)}}>add above</a>}</List.Item>
                        <List.Item>{this.props.editmode && <a onClick={()=>{this.addRule(ruleid+1)}}>add below</a>}</List.Item>
                        {ruleid !== 0 && <List.Item><a onClick={()=>{this.moveRuleUp(ruleid)}}>move up</a></List.Item>}
                        {ruleid < this.state.decisionRules.length-1 && <List.Item><a onClick={()=>{this.moveRuleDown(ruleid)}}>move down</a></List.Item>}
                        </List>
                      </Table.Cell>
                    </Table.Row>
                    </Table.Body>
                })}
               
                </Table>
                </div>
    
    );  

  
    }
  }